import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { GoVideo } from "react-icons/go";
import ReactPlayer from "react-player";
import "./VideoSection.css";

export default function VideoSection(props) {
  return (
    <Container>
      <Row>
        <Col className="video-section-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <GoVideo
              style={{ color: props.iconColor }}
              className="video-section-icon"
            />
            {props.titleContent}
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="video-section-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            {props.subTextContent}
          </p>
        </Col>
      </Row>
      <Row className="video-section-row">
        <Col className="video-section-third-col">
          <ReactPlayer
            style={{
              width: "100%",
              height: "100%",
            }}
            controls={true}
            src={props.videoLink}
          />
        </Col>
      </Row>
    </Container>
  );
}
